import { enumToList } from '~/client/src/shared/utils/converters'

import Localization from '../../shared/localization/LocalizationManager'

enum FormReportFilterType {
  COMPANY = 'company',
  STATUS = 'status',
  LOCATION = 'location',
  EQUIPMENT = 'equipment',
}

export const getFormReportFilterTypeCaption = (type: FormReportFilterType) => {
  switch (type) {
    case FormReportFilterType.COMPANY:
      return Localization.translator.company
    case FormReportFilterType.STATUS:
      return Localization.translator.status
    case FormReportFilterType.LOCATION:
      return Localization.translator.location
    case FormReportFilterType.EQUIPMENT:
      return Localization.translator.equipment
    default:
      throw new Error(type + ' is unhandled')
  }
}

export const formReportFilterTypes = enumToList(FormReportFilterType)

export default FormReportFilterType
